import React from 'react';
import {useParams} from 'react-router-dom';
import {
  FeatureFlagEnum,
  ModuleEnum,
  TaskTypeEnum,
} from 'src/api/ProactApiClient';
import {BackBar} from 'src/app/layout/BackBar';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';
import {PageHeader} from 'src/design/organisms/PageHeader';
import {SupervisorApprovalForm} from 'src/app/tasks/SupervisorApprovalForm';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import {useTaskBreadcrumbs} from 'src/shared/hooks/useTaskBreadcrumbs';

export interface ViewTaskSupervisorApprovalPageProps {
  taskType: TaskTypeEnum;
}
const ViewTaskSupervisorApprovalPage: React.FC<
  ViewTaskSupervisorApprovalPageProps
> = ({taskType}) => {
  const {taskId} = useParams();

  const breadcrumbs = useTaskBreadcrumbs({
    taskType,
    mode: 'supervisor-approval',
  });

  return (
    <ContentWrapper>
      <BackBar
        fallbackTo={PathUtility.TasksDashboard(taskType, 'supervisor-approval')}
        breadcrumbs={breadcrumbs}
      />
      <PageHeader>
        <PageHeader.Title>Supervisor Approval</PageHeader.Title>
      </PageHeader>
      {taskId && <SupervisorApprovalForm taskId={Number(taskId)} />}
    </ContentWrapper>
  );
};

// Register the routes with the new system
[
  {
    type: TaskTypeEnum.Approval,
    featureFlag: FeatureFlagEnum.Approvals,
    module: ModuleEnum.Approvals,
  },
  {
    type: TaskTypeEnum.ToolboxTalk,
    featureFlag: FeatureFlagEnum.ToolboxTalks,
    module: ModuleEnum.ToolboxTalks,
  },
  {
    type: TaskTypeEnum.Form,
    featureFlag: FeatureFlagEnum.Forms,
    module: ModuleEnum.AssignedForms,
  },
].forEach(item => {
  routeRegistry.registerPageRoute({
    backNavigation: 'page',
    path: PathUtility.ViewTaskSupervisorApproval(item.type, ':taskId'),
    element: <ViewTaskSupervisorApprovalPage taskType={item.type} />,
    isPrivate: true,
  });
});

export default ViewTaskSupervisorApprovalPage;
